<template>
  <div class="claim-button-container">
    <button class="pixel2" @click="claimReward" :disabled="!isClaimButtonActive || isPosting" :class="{ 'shake': isClaimButtonActive }">
      <img src="@/assets/startup.png" alt="">
      CLAIM
    </button>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: ['telegramId', 'username', 'reference', 'userId'],
  data() {
    return {
      isPosting: false
    };
  },
  computed: {
    ...mapGetters(['isClaimButtonActive'])
  },
  methods: {
    claimReward() {
      if (this.isClaimButtonActive && !this.isPosting) {
        this.isPosting = true; // Butonu devre dışı bırak
        axios.post('https://sys.bitherin.com/claim-reward', {
          telegram_id: this.telegramId,
          username: this.username,
          ref: this.reference,
          user_id: this.userId
        }).then(response => {
          console.log('Response:', response.data);
          this.$store.dispatch('fetchUserData', {
            telegramId: this.telegramId,
            username: this.username,
            ref: this.reference
          });
          this.$store.commit('STOP_VIRTUAL_BALANCE_UPDATE');
          this.isPosting = false; // İşlem tamamlandığında butonu tekrar etkinleştir
        }).catch(error => {
          console.error('Error:', error);
          this.isPosting = false; // Hata durumunda butonu tekrar etkinleştir
        });
      }
    }
  }
}
</script>

<style scoped>
.claim-button {
  width: 100%;
  padding: 7px;
  background: linear-gradient(to right, #ffa500, #ff4500);
  color: #fff;
  border: none;
  border-radius: 15px;
  font-size: 1.5rem;
  margin-top: 20px;
  transition: background-color 0.3s;
  font-family: 'Digital-7', sans-serif;
}

.claim-button:hover {
  background-color: #ff8c00;
}

.claim-button:disabled {
  background: #999;
}

.claim-button.shake, .pixel2.shake {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

.pixel2 {
  position: relative;
  display: block;
  margin: 10px;
  font-family: 'Digital-7', sans-serif;
  font-size: 1.7rem;
  color: white;
  padding: 5px;
  width: auto;
  z-index: 2;
  background: linear-gradient(to right, #ffa500, #ff4500);
  border: none;
}

.pixel2::before {
  content: "";
  display: block;
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: -10px;
  right: -10px;
  background: linear-gradient(to right, #ffa500, #ff4500);
  z-index: -1;
}

.pixel2::after {
  content: "";
  display: block;
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: -6px;
  right: -6px;
  background: linear-gradient(to right, #ffa500, #ff4500);
  z-index: -1;
}

.pixel2:disabled {
  background: linear-gradient(to right, #566A60, #092127, #0e333c);
}

.pixel2:disabled::before,
.pixel2:disabled::after {
  background: linear-gradient(to right, #566A60, #092127, #0e333c);
}

.pixel2 img {
  margin-right: 8px;
}
</style>
